// extracted by mini-css-extract-plugin
module.exports = {"currency_price":"Currency_currency_price__2xf07"};